import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { motion } from "framer-motion";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#05081A] px-4">
      <motion.div 
        className="text-center"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="relative inline-block mb-4">
          <h1 className="text-8xl font-bold text-white">404</h1>
          <div className="absolute bottom-4 left-0 w-full h-2 bg-[#BFFF00] -z-10"></div>
        </div>
        
        <p className="text-2xl font-semibold text-white/90 mt-6">
          Pagina niet gevonden
        </p>
        <p className="text-gray-300 mt-3 mb-8 max-w-md mx-auto">
          De pagina die u zoekt bestaat niet of is verplaatst. Klik op de knop hieronder om terug te gaan naar het dashboard.
        </p>
        
        <Button 
          asChild
          className="bg-[#BFFF00] hover:bg-[#a8e600] text-[#05081A] font-medium px-6 py-2"
        >
          <Link to="/dashboard">Terug naar dashboard</Link>
        </Button>
      </motion.div>
    </div>
  );
};

export default NotFound;